export default "__VITE_ASSET__GoWMzzSB__"